import styled from 'styled-components';

import { useOrderFormView } from '#/features/perpetuals/order-builder/form-context';
import { useTranslation } from '#/features/localization/utils';

import Tooltip, { HelpUnderline } from '#/components/shared/Tooltip';
import Description from '#/components/perpetuals/Description';

export default function OrderSummary() {
  const formView = useOrderFormView();
  const { t } = useTranslation();

  return (
    <Container>
      <Description
        label={
          <Tooltip label={formView.feeTooltip}>
            <HelpUnderline>{t('Fee')}</HelpUnderline>
          </Tooltip>
        }
        value={formView.feeRange}
      />

      <Description
        label={t('Notional')}
        value={formView.notionalQuoteAsset.formattedValue}
      />
    </Container>
  );
}

export const Container = styled.div`
  display: grid;
  gap: 12px;
`;
